export const TEST_ID = 'detailsViewCardHeader';
